import makeList from './makeList.js'

let viewFloor = '管理棟1F'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '管理棟１階階段',
        file: './data/I18a_1.JPG',
        rotation: 139.57441280226794,
        link: [
          {
            file: './data/I18z.JPG',
            position: [ -4940.2209316824255, -396.8007860700383, 625.338614984417 ],
          },
          {
            file: './data/I18b_1.JPG',
            position: [ 3203.933314548247, -87.3878542775745, -3826.0744702494094 ],
          },
          {
            file: './data/I18l_.jpg',
            position: [ 562.1110174670908, 113.90742679854065, -4961.833215506157 ],
          },
          {
            file: './data/I18c_2.JPG',
            position: [ 4274.591195963774, 1903.6658702788743, 1746.7654405398034 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 517.948717948718, 348.8974358974359 ],
        },
      },
      { description: '空調機械室',
        file: './data/I18z.JPG',
        rotation: -7.872977756871672,
        link: [
          {
            file: './data/I18a_1.JPG',
            position: [ 3654.6956584194786, -607.8707174905884, -3348.879338003009 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 605.1282051282052, 400.1794871794872 ],
        },
      },
      { description: '管理棟１階(倉庫)',
        file: './data/I18b_1.JPG',
        rotation: -8.877353032468307,
        link: [
          {
            file: './data/I18a_1.JPG',
            position: [ -3858.2153830583648, 2135.9106232910704, 2340.751903259464 ],
          },
          {
            file: './data/09_R0010761.JPG',
            position: [ 4449.211893397951, 1300.3443355686354, -1852.8382898555333 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 428.20512820512823, 279.66666666666663 ],
        },
      },
      { description: '食料倉庫',
        file: './data/I18l_.jpg',
        rotation: -159.62429666641248,
        link: [
          {
            file: './data/I18a_1.JPG',
            position: [ 2873.3438098884403, 641.1372856252868, 4034.2517156218823 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 592.3076923076924, 287.35897435897425 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
